import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { wechatLogin } from '@zaogig/auth';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'bind' | 'error'>('loading');
  const [message, setMessage] = useState('正在处理微信登录...');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setStatus('error');
      setMessage('缺少授权码');
      return;
    }

    wechatLogin(code)
      .then((res) => {
        if (res.next_step === 'bind_wechat') {
          setStatus('bind');
          setMessage('请绑定手机号');
          navigate('/bind-wechat?code=' + code, { replace: true });
        } else {
          setStatus('success');
          setMessage('登录成功，正在跳转...');
          setTimeout(() => navigate('/', { replace: true }), 1000);
        }
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || '微信登录失败');
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50/50 via-white to-blue-50/50">
      <div className="text-center">
        {status === 'loading' && <Loader2 className="h-12 w-12 animate-spin text-emerald-600 mx-auto" />}
        {status === 'success' && <CheckCircle2 className="h-12 w-12 text-green-500 mx-auto" />}
        {status === 'error' && <XCircle className="h-12 w-12 text-red-500 mx-auto" />}
        {status === 'bind' && <Loader2 className="h-12 w-12 animate-spin text-amber-500 mx-auto" />}
        <p className="mt-4 text-lg font-medium text-slate-700">{message}</p>
      </div>
    </div>
  );
}
